import React from 'react'
import './my-practice.css'
import { Link } from "react-router-dom";
import AppLayout from '../App';

function MyPractice() {
  return (
    <AppLayout>
      <div className='my-practice__container'>
        <div className="my-practice__content">
          <h2 className="my-practice__title">
            ABOUT MY PRACTICE
          </h2>
          <section className="my-practice__session-section">
            <div className="my-practice__session-content">
              <p>My work is based on Brennan Healing Science®, a therapeutic modality that works with the physical, emotional, mental, and spiritual layers of the human energy field to restore flow, coherence, and vitality.</p>
              <p>It's a grounded, lineage-based practice developed by Barbara Brennan, blending intuitive perception with hands-on techniques. </p>
              <p>Brennan healers and practitioners are trained through a 4-6 year program that integrates psycho-spiritual development, Core Energetics principles, intuitive perception, and deep group process work.</p>
            </div>
            <div className="my-practice__session-image">
              <img
                src="/images/long-hair.jpeg"
                alt="Energy healing session"
              />
            </div>
          </section>
          <h2 className="my-practice__title">
            WHAT ARE SESSIONS LIKE
          </h2>
          <section className="my-practice__session-section">
            <div className="my-practice__session-image">
              <img
                src="/images/womb-heart.jpeg"
                alt="Energy healing session"
              />
            </div>
            <div className="my-practice__session-content">
              <p>
                Energy healing sessions are an invitation to slow down,
                turn inward, and reconnect with yourself.
              </p>

              <p>
                We begin by exploring what is currently alive in your
                life, whether that is a challenge, a symptom, a life
                transition, or a deeper longing. Together, we set an
                intention for the session and allow that intention to
                guide our work.
              </p>

              <p>
                I offer remote healing sessions online, in-person sessions 
                in London are only available by request. For in-person sessions, 
                you will lie comfortably on a healing table. For online sessions, 
                you will be invited to create a quiet space where you can rest undisturbed.
                Sessions are fully clothed.
              </p>

              <p>
                As the session unfolds, I work with your energy field to
                support greater balance, awareness, and well-being. Each
                session is unique and responds to what is seeking
                attention in the moment.
              </p>
            </div>
          </section>

          <h2 className="my-practice__title">
            WHAT YOU COULD EXPERIENCE
          </h2>

          <section className="my-practice__session-section">
            <div className="my-practice__session-content">
              <p>Everyone experiences an energy  healing differently. Some common experiences while lying down include sensations of heat, internal movement, visual images such as colours or memories, emotional release, entering a deep state of relaxation, and/or moments of mental resistance.</p>
              <p>Through this practice, you may:</p>
              <ul>
                <li>Deepen your connection to yourself</li>
                <li>Clarify your desires</li>
                <li>Trust your inner guidance</li>
                <li>Discover more of who you are</li>
                <li>Meet wounds and resistance with compassion</li>
                <li>Reconnect with creativity</li>
                <li>Cultivate greater well-being</li>
                <li>Trust life's unfolding</li>
                <li>Feel more authentic</li>
                <li>Feel more alive</li>
              </ul>
            </div>
              <div className="my-practice__session-image">
                <img
                  src="/images/pandora.jpeg"
                  alt="Energy healing session"
                />
              </div>
          </section>
          <section className="my-practice__pricing">
            <h2 className="my-practice__title">
              WORKING TOGETHER
            </h2>
            <p className="my-practice__pricing-subtitle">
              <p>All sessions are held online, with in-person sessions in London available upon request.</p>
            </p>

            <div className="my-practice__pricing-grid">
              <div className="my-practice__pricing-card">
                <h3>Discovery<br />  Call</h3>

                <p>
                  A complimentary conversation to explore whether this
                  work feels aligned for you.
                </p>

                <div className="my-practice__pricing-meta">
                  <span>30 Minutes</span>
                  <span>Free</span>
                </div>
              </div>

              <div className="my-practice__pricing-card">
                {/* <h3>Energy <br /> Healing Session</h3> */}
                <h3>Energy Healing <br />Session</h3>

                <p>
                  A one-to-one energy healing session tailored to what is currently alive in your life, offering support, clarity, and space for deeper self-connection.
                </p>

                <div className="my-practice__pricing-meta">
                  <span>75 Minutes</span>
                  <span>£80</span>
                </div>
              </div>

              {/* <div className="my-practice__pricing-card">
                <h3>3 x Energy <br /> Healing Sessions</h3>
                <p>
                  A series of three 75-minute one-to-one energy healing sessions to work together over time, supporting deeper exploration, integration, and meaningful shifts in awareness.
                </p>

                <div className="my-practice__pricing-meta">
                  <span>3 Sessions</span>
                  <span>£225</span>
                </div>
              </div>

              <div className="my-practice__pricing-card">
                <h3>5 x Energy <br /> Healing Sessions</h3>
                <p>
                  A longer-term container for sustained healing and self-discovery. Through ongoing support, we create space for deeper transformation and lasting change.
                </p>

                <div className="my-practice__pricing-meta">
                  <span>5 Sessions</span>
                  <span>£350</span>
                </div>
              </div> */}

              {/* <div className="my-practice__pricing-card">
                <h3>10 x Energy <br /> Healing Sessions</h3>
                <p>
                  A longer-term container of ten 75-minute sessions for profound healing and self-discovery. Through sustained support, we create space for lasting change and a deeper relationship with yourself.
                </p>
                <div className="my-practice__pricing-meta">
                  <span>10 Sessions</span>
                  <span>£700</span>
                </div>
              </div> */}
            </div>

            <div className="my-practice__pricing-cta">
              <Link to="/contact" className="my-practice__pricing-button">
                RESERVE
              </Link>
            </div>
          </section>
        </div>
      </div>
    </AppLayout>
  )
}


export default MyPractice